/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GeoRegionResponse } from '../models/GeoRegionResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class GeoRegionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List geo regions
     * Returns a paginated list of geo regions with optional type and search filters. Used by admin for provisioning municipality communes.
     * @returns any List of geo regions.
     * @throws ApiError
     */
    public geoRegionsControllerFindAll({
        page = 1,
        limit = 20,
        type,
        search,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Filter by region type
         */
        type?: 'COMMUNE' | 'DEPARTEMENT' | 'REGION',
        /**
         * Search by region name (case-insensitive)
         */
        search?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/geo-regions',
            query: {
                'page': page,
                'limit': limit,
                'type': type,
                'search': search,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * Get geo region by ID
     * Returns a single geo region by its unique identifier.
     * @returns GeoRegionResponse Geo region found.
     * @throws ApiError
     */
    public geoRegionsControllerFindOne({
        id,
    }: {
        /**
         * Geo region unique identifier
         */
        id: string,
    }): CancelablePromise<GeoRegionResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/geo-regions/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
                404: `Geo region not found.`,
            },
        });
    }
    /**
     * Get GeoJSON for selected regions
     * Returns a GeoJSON FeatureCollection with boundaries and area (km²) for the given geo region IDs. Used to visualize commune coverage on a map.
     * @returns any GeoJSON FeatureCollection with commune boundaries.
     * @throws ApiError
     */
    public geoRegionsControllerFindByIds({
        requestBody,
    }: {
        requestBody: {
            /**
             * Array of geo region IDs
             */
            ids: Array<string>;
        },
    }): CancelablePromise<Array<GeoRegionResponse>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/geo-regions/by-ids',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
    /**
     * Get GeoJSON for selected regions
     * Returns a GeoJSON FeatureCollection with boundaries and area (km²) for the given geo region IDs. Used to visualize commune coverage on a map.
     * @returns any GeoJSON FeatureCollection with commune boundaries.
     * @throws ApiError
     */
    public geoRegionsControllerFindByIdsGeoJson({
        requestBody,
    }: {
        requestBody: {
            /**
             * Array of geo region IDs
             */
            ids: Array<string>;
        },
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/geo-regions/by-ids/geojson',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Admin role required.`,
            },
        });
    }
}
